import React from "react";
import { Box, Tabs, Tab, Breadcrumbs, Link, Typography, Paper } from "@mui/material";
import { Link as RouterLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { ANALYTICS_TABS } from "./analyticsTabs";

const PURPLE = "#7c3aed";

export default function AnalyticsLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeIndex = Math.max(
    0,
    ANALYTICS_TABS.findIndex(
      (t) => location.pathname === t.path || location.pathname.startsWith(`${t.path}/`)
    )
  );
  const activeTab = ANALYTICS_TABS[activeIndex] || ANALYTICS_TABS[0];

  return (
    <Box>
      <Breadcrumbs sx={{ mb: 1.5, fontSize: 13 }}>
        <Link component={RouterLink} to="/admin/dashboard" underline="hover" color="inherit">
          Dashboard
        </Link>
        <Typography color="text.secondary">Analytics</Typography>
        <Typography color="text.primary">{activeTab.breadcrumb}</Typography>
      </Breadcrumbs>

      <Paper
        sx={{
          mb: 2,
          borderRadius: 3,
          border: "1px solid #eef0f4",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
          overflow: "hidden",
        }}
      >
        <Tabs
          value={activeIndex}
          onChange={(_, idx) => navigate(ANALYTICS_TABS[idx].path)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 48,
            px: { xs: 0.5, sm: 1 },
            bgcolor: "#fafafa",
            borderBottom: "1px solid #eef0f4",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: { xs: "0.8rem", sm: "0.875rem" },
              minHeight: 48,
              color: "#64748b",
            },
            "& .Mui-selected": { color: PURPLE },
            "& .MuiTabs-indicator": { backgroundColor: PURPLE, height: 3 },
          }}
        >
          {ANALYTICS_TABS.map((tab) => (
            <Tab key={tab.slug} label={tab.label} />
          ))}
        </Tabs>
      </Paper>

      <Outlet />
    </Box>
  );
}
